import { ErrorAPI } from 'api/Associado/methods';
import { getToastError } from './ToasterUtils';

export default function (error: ErrorAPI) {
  if (Array.isArray(error.details) && error.details.length > 0) {
    getToastError(error.details[0].message);
  } else {
    getToastError(error.message);
  }
}
